import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
import { FAQS } from "../../data/content";
import { Reveal } from "./Reveal";
import { SectionEyebrow } from "./About";

export const Faq = () => {
  const [open, setOpen] = useState(0);
  return (
    <section
      id="faq"
      data-testid="faq"
      className="relative border-t px-6 py-28 lg:px-10 lg:py-36"
      style={{ borderColor: "var(--border)" }}
    >
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <Reveal>
              <SectionEyebrow index="07">Questions</SectionEyebrow>
              <h2 className="font-head mt-6 text-4xl leading-tight text-[color:var(--text)] sm:text-5xl">
                Answers, before you ask.
              </h2>
            </Reveal>
          </div>

          <div className="lg:col-span-7 lg:col-start-6">
            <div className="border-t" style={{ borderColor: "var(--border)" }}>
              {FAQS.map((f, i) => {
                const active = open === i;
                return (
                  <Reveal key={f.q} delay={i * 0.04}>
                    <div className="border-b" style={{ borderColor: "var(--border)" }}>
                      <button
                        data-testid={`faq-${i}`}
                        onClick={() => setOpen(active ? -1 : i)}
                        className="flex w-full items-center gap-5 py-6 text-left"
                      >
                        <span className="font-head flex-1 text-lg text-[color:var(--text)] sm:text-xl">
                          {f.q}
                        </span>
                        <span
                          className="flex h-8 w-8 shrink-0 items-center justify-center border transition-colors"
                          style={{
                            borderColor: "var(--border)",
                            background: active ? "var(--accent)" : "transparent",
                            color: active ? "var(--on-accent)" : "var(--text)",
                          }}
                        >
                          {active ? <Minus size={15} /> : <Plus size={15} />}
                        </span>
                      </button>
                      <AnimatePresence initial={false}>
                        {active && (
                          <motion.div
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: "auto", opacity: 1 }}
                            exit={{ height: 0, opacity: 0 }}
                            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                            className="overflow-hidden"
                          >
                            <p className="max-w-xl pb-7 text-[15px] leading-relaxed text-[color:var(--text-2)]">
                              {f.a}
                            </p>
                          </motion.div>
                        )}
                      </AnimatePresence>
                    </div>
                  </Reveal>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
